export interface AlertFilters {
  titleTags: string[]
  contactTags: string[]
  duration: number | null
  distance: number | null
  showDisabled: boolean
  showEnabled: boolean
  showNoContacts: boolean
}

export const DEFAULT_ALERT_FILTERS: AlertFilters = {
  titleTags: [],
  contactTags: [],
  duration: null,
  distance: null,
  showDisabled: true,
  showEnabled: true,
  showNoContacts: true,
}

export const countActiveFilters = (filters: AlertFilters): number => {
  let count = 0
  if (filters.titleTags.length > 0) count++
  if (filters.contactTags.length > 0) count++
  if (filters.duration !== null) count++
  if (filters.distance !== null) count++
  if (!filters.showDisabled || !filters.showEnabled || !filters.showNoContacts) count++
  return count
}
